<div class="flex-row">
    <div class="d-flex col-12 justify-content-center">
        <div class="text-center text-secondary">
            <em class="icon icon-xl d-inline-block">search</em>
            <div class="h4">{{title}}</div>
            <p translate>{{subTitle}}</p>
        </div>
    </div>
</div>